window.__questionBuilder = {

    __types: {
        "option": {
            "title": "Çoktan Seçmeli",
            "hasOptions": true,
        },
        "checkbox": {
            "title": "Onay Kutusu",
            "hasOptions": true,
        },
        "dropdown": {
            "title": "Açılır Menü",
            "hasOptions": true,
        },
        "textarea": {
            "title": "Cevap Kutusu",
            "hasOptions": false,
        }
    },

    addRadio: function(question, values, id, description) {
        question = question || "";
        values = values || false;

        let parent = document.getElementById("application-custom-questions");
        let element = this.__generateQuestion("option", question, values, id, description);
        parent.appendChild(element);
        return false;
    },

    addCheckbox: function(question, values, id, description) {
        question = question || "";
        values = values || false;

        let parent = document.getElementById("application-custom-questions");
        let element = this.__generateQuestion("checkbox", question, values, id, description);
        parent.appendChild(element);
        return false;
    },

    addDropdown: function(question, values, id, description) {
        question = question || "";
        values = values || false;

        let parent = document.getElementById("application-custom-questions");
        let element = this.__generateQuestion("dropdown", question, values, id, description);
        parent.appendChild(element);
        return false;
    },

    addTextarea: function(question, value, id, description) {
        question = question || "";
        value = value || "";

        let parent = document.getElementById("application-custom-questions");
        let element = this.__generateQuestion("textarea", question, value, id, description);
        parent.appendChild(element);
        return false;
    },

    addOption: function(elm) {
        let parent = elm.closest('.form-builder-question');
        let optionsContainer = parent.querySelector('.form-builder-question-options');

        optionsContainer.appendChild(this.__generateOption());

        return false;
    },

    removeOption: function(elm) {
        let parent = elm.closest('.form-row');

        parent.remove();

        return false;
    },

    removeQuestion: function(elm) {
        let parent = elm.closest('.form-builder-question');

        parent.remove();

        return false;
    },

    __generateQuestion: function(type, question, values, id, description) {
        type = type || "textarea";
        question = question || "";
        values = values || false;
        description = description || false;
        id = id || this.__randomId(9);

        let hasOptions = this.__types[type] && this.__types[type].hasOptions;

        let wrapper = this.__generateQuestionWrapper(type, id);

        wrapper.appendChild(this.__generateQuestionHeader(type, question));
        wrapper.appendChild(this.__generateQuestionDescriptionHeader(description));

        if (hasOptions) {
            wrapper.appendChild(this.__generateOptionsTextElement());

            let optionWrapper = this.__generateOptionWrapper(type);

            if (values.length) {
                for (let i = 0; i < values.length; i++) {
                    optionWrapper.appendChild(this.__generateOption(values[i]));
                }
            } else {
                optionWrapper.appendChild(this.__generateOption());
            }

            wrapper.appendChild(optionWrapper);
        }

        wrapper.appendChild(this.__generateQuestionFooter(hasOptions));

        return wrapper;
    },

    __generateQuestionWrapper: function(type, id) {
        let wrapper = document.createElement('div');
        wrapper.className = "form-builder-question";
        wrapper.setAttribute("data-type", type);
        wrapper.setAttribute("data-id", id);

        return wrapper;
    },

    __generateQuestionHeader: function(type, question) {

        type = type || false;
        question = question || "";

        let header = document.createElement('div');
        header.className = 'form-row';

        let title = "";

        if (type && this.__types[type]) {
            title = this.__types[type].title;
        }

        header.innerHTML = `
        <div class="form-control-wrapper">
            <div class="form-label">
                <label for="">${title}</label>
            </div>
            <div class="form-input">
                <input type="text" class="form-control form-builder-control form-builder-question-text" placeholder="Soru Başlığı" value="${question}" required>
            </div>
        </div>`;

        return header;
    },

    __generateQuestionDescriptionHeader: function(description) {

        description = description || "";

        let header = document.createElement('div');
        header.className = 'form-row';

        header.innerHTML = `
        <div class="form-control-wrapper">
            <div class="form-label">
                <label for="">Soru Açıklaması</label>
            </div>
            <div class="form-input">
                <input type="text" class="form-control form-builder-control form-builder-description-text" placeholder="Açıklama" value="${description}">
            </div>
        </div>`;

        return header;
    },

    __generateOptionsTextElement: function(text) {
        text = text || "Seçenekler";

        let element = document.createElement('p');
        element.className = 'fw-500';
        element.innerText = text;

        return element;
    },

    __generateOptionWrapper: function(type) {
        type = type || false;

        let wrapper = document.createElement('div');
        wrapper.className = 'form-builder-question-options';

        if (type) {
            wrapper.classList.add('form-builder-question-options--' + type);
        }

        return wrapper;
    },

    __generateQuestionFooter: function(hasOptions) {
        hasOptions = hasOptions || false;

        let footer = document.createElement('div');
        footer.className = 'd-flex justify-content-between';

        footer.innerHTML = '';

        if (hasOptions) {
            footer.innerHTML = `
            <button onclick="return __questionBuilder.addOption(this)" type="button" class="button button--gray me-2 my-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="me-1" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd"></path>
                </svg>
                <span>Seçenek Ekle</span>
            </button>
            `;
        }

        footer.innerHTML += `
        <button class="remove-question-button button button--red my-2" onclick="return __questionBuilder.removeQuestion(this)" type="button">
            <span>Soruyu kaldır</span>
        </button>`;

        return footer;
    },

    __generateOption: function(value) {
        value = value || "";

        let row = document.createElement('div');
        row.className = "form-row";

        row.innerHTML = `
        <div class="form-control-wrapper">
            <div class="form-input">
                <span class="form-input-prefix"></span>
                <input type="text" class="form-control fb_question_option" placeholder="Seçenek" value="${value}">
                <button class="remove-option-button" type="button" onclick="return __questionBuilder.removeOption(this)">Sil</button>
            </div>
        </div>`;

        return row;
    },

    __randomId: function(length) {
        length = length || 9;

        let alphabet = "abcdefghijklmnopqrstuvwxyz0123456789";

        let string = "";

        for (let i = 0; i < length; i++) {
            string += alphabet[Math.floor(Math.random() * alphabet.length)];
        }

        return string;
    }
}

let existingQuestions = document.getElementById("application-custom-fields-value");
if (existingQuestions && existingQuestions.value.trim().length) {

    try {
        let questionsArr = JSON.parse(existingQuestions.value.trim());

        for (let i = 0; i < questionsArr.length; i++) {

            let type        = questionsArr[i].type || false;
            let description = questionsArr[i].description || false;
            let question    = questionsArr[i].question || false;
            let values      = questionsArr[i].options || false;
            let id          = questionsArr[i].id || false;

            switch (type) {
                case "radio":
                case "option":
                    window.__questionBuilder.addRadio(question, values, id, description);
                    break;
                case "checkbox":
                    window.__questionBuilder.addCheckbox(question, values, id, description);
                    break;
                case "dropdown":
                    window.__questionBuilder.addDropdown(question, values, id, description);
                    break;
                case "textarea":
                case "text":
                    window.__questionBuilder.addTextarea(question, values, id, description);
                    break;
                default:
                    console.error("Bilinmeyen tür: " + type);
            }

        }

    } catch (e) {
        console.error(e);
    }
}

let applicationSaveButton = document.getElementById("application-save-button");
if (applicationSaveButton) {

    let applicationForm = applicationSaveButton.closest('form');
    applicationForm.onsubmit = function() {

        if(applicationForm.reportValidity != undefined) {

            if (!applicationForm.reportValidity()) {
                return false;
            }

        }

        let questionsElement = document.getElementById("application-custom-questions");

        let questionsArr = Array.from(questionsElement.querySelectorAll('.form-builder-question')).map(function(questionRow) {

            let question = {};

            let type            = questionRow.getAttribute('data-type');
            let questionText    = questionRow.querySelector(".form-builder-question-text").value.trim();
            let descriptionText = questionRow.querySelector(".form-builder-description-text").value.trim();

            question["id"]       = questionRow.getAttribute("data-id") || ("copt_" + window.__questionBuilder.__randomId(9));
            question["type"]     = type;
            question["question"] = questionText;

            if (descriptionText.length) {
                question["description"] = descriptionText;
            }

            let hasOptions = window.__questionBuilder.__types[type] && window.__questionBuilder.__types[type].hasOptions;

            if (hasOptions) {
                let options = Array.from(questionRow.querySelectorAll(".form-builder-question-options .fb_question_option")).map(_ => _.value.trim()).filter(_ => _.length)
                question["options"] = options;
            }


           return question;

        }).filter(function(question) {
            return question.options == undefined || question.options.length;
        });

        existingQuestions.value = JSON.stringify(questionsArr);

        return true;
    }
}
